import { Platform } from '@angular/cdk/platform';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Location } from "@angular/common";
import { AuthService } from '../core/services/auth.service';
import { DataService } from '../core/services/data.service';
import { EncryptionService } from '../core/services/encryption.service';
import { EventService } from '../core/services/event.service';
import { VersionService } from '../core/services/version.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { firstValueFrom, map, Observable, startWith, timeout } from 'rxjs';
import { addMinutes } from '../utils/date.utils';
import { isPaidPlanName } from '../utils/plan.utils';
import { FEATURE_EVENT_BRANDING, isFeatureEnabled } from '../utils/feature.utils';
import { DateTime } from 'luxon';
import { ToastService } from '../core/services/toast.service';
import { CoverImageComponent } from '../cover-image/cover-image.component';
import { MatDialog } from '@angular/material/dialog';
import { InviteDialogComponent } from '../invite-dialog/invite-dialog.component';
import { openInviteShareDialog } from '../invite-share/open-invite-share';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { createS3Client, createCognitoCredentials, createUpload } from '../utils/aws-s3.util';
import { CANVA_TEMPLATES, CanvaTemplate } from '../core/data/canva-templates';
import { CanvaTemplateService } from '../core/services/canva-template.service';
import { Subscription } from 'rxjs';
import { reloadApp } from '../core/utils/reload-app';
import { inviteLinkFor } from '../core/utils/invite-link';
@Component({
  selector: 'app-update-event',
  templateUrl: './update-event.component.html',
  styleUrls: ['./update-event.component.css']
})
export class UpdateEventComponent implements OnInit, OnDestroy {


  start_Time: Date | undefined;
  isPast: boolean = false;
  isAnyLive: any = false;
  version: string;
  eventData: any;
  eventId: any;
  userId: any;
  inviteData: any;
  isHost: any;
  isLoading: boolean = false;
  private qrPrefetchDone: boolean = false;
  private qrPrefetchInFlight: boolean = false;
  event: any;
  collaborators: any = [];
  isScheduled: any;
  filteredGuests = [...this.collaborators];
  selectedFilter: 'all' | 'yes' | 'no' | 'maybe' = 'all';
  isGuestLoading: boolean = false;
  showChangeHostModal: boolean = false;
  hostTransferSent: boolean = false;
  selectedGuestForHostTransfer: any = null;
  hostTransferPendingUserId: string | null = null;
  hostTransferTransitionId: string | null = null;
  isHostTransferLoading: boolean = false;
  eventTotalFiles: number = 0;
  eventStorage: string = '';
  eventStorageBytes: number = 0;
  eventImageCount: number = 0;
  eventVideoCount: number = 0;
  currentSection = 1;
  sections = [
    { title: 'Title' },
    { title: 'Event Details' },
    { title: 'Guests' },
    { title: 'Branding' }
  ];

  // Branding form properties
  brandingForm!: FormGroup;
  isBrandingLoading: boolean = false;
  isSavingBranding: boolean = false;
  logoUrl: string | null = null;
  logoFile: File | null = null;
  originalBrandingFormValues: any;
  isBrandingActive: boolean = true;
  private identityPoolId: string = environment.aws.IdentityPoolId;
  private generatedLogoName: string | null = null;
  private existingLogoName: string | null = null;

  timezones = [
    { label: 'Local Time', value: Intl.DateTimeFormat().resolvedOptions().timeZone },
    { label: 'UTC', value: 'UTC' },
    // Americas
    { label: 'America/New_York (EST/EDT) - US East', value: 'America/New_York' },
    { label: 'America/Chicago (CST/CDT) - US Central', value: 'America/Chicago' },
    { label: 'America/Denver (MST/MDT) - US Mountain', value: 'America/Denver' },
    { label: 'America/Los_Angeles (PST/PDT) - US West', value: 'America/Los_Angeles' },
    { label: 'America/Phoenix (MST) - Arizona', value: 'America/Phoenix' },
    { label: 'America/Anchorage (AKST) - Alaska', value: 'America/Anchorage' },
    { label: 'Pacific/Honolulu (HST) - Hawaii', value: 'Pacific/Honolulu' },
    // Canada
    { label: 'America/Toronto (EST/EDT) - Canada East', value: 'America/Toronto' },
    { label: 'America/Vancouver (PST/PDT) - Canada West', value: 'America/Vancouver' },
    { label: 'America/Edmonton (MST/MDT) - Canada Mountain', value: 'America/Edmonton' },
    { label: 'America/Winnipeg (CST/CDT) - Canada Central', value: 'America/Winnipeg' },
    { label: 'America/Halifax (AST/ADT) - Canada Atlantic', value: 'America/Halifax' },
    { label: 'America/St_Johns (NST/NDT) - Newfoundland', value: 'America/St_Johns' },
    // South America
    { label: 'America/Sao_Paulo - Brazil', value: 'America/Sao_Paulo' },
    { label: 'America/Buenos_Aires - Argentina', value: 'America/Buenos_Aires' },
    { label: 'America/Santiago - Chile', value: 'America/Santiago' },
    { label: 'America/Bogota - Colombia', value: 'America/Bogota' },
    { label: 'America/Lima - Peru', value: 'America/Lima' },
    { label: 'America/Mexico_City - Mexico', value: 'America/Mexico_City' },
    // Europe
    { label: 'Europe/London (GMT/BST) - UK', value: 'Europe/London' },
    { label: 'Europe/Paris (CET/CEST) - France', value: 'Europe/Paris' },
    { label: 'Europe/Berlin (CET/CEST) - Germany', value: 'Europe/Berlin' },
    { label: 'Europe/Rome (CET/CEST) - Italy', value: 'Europe/Rome' },
    { label: 'Europe/Madrid (CET/CEST) - Spain', value: 'Europe/Madrid' },
    { label: 'Europe/Amsterdam (CET/CEST) - Netherlands', value: 'Europe/Amsterdam' },
    { label: 'Europe/Brussels (CET/CEST) - Belgium', value: 'Europe/Brussels' },
    { label: 'Europe/Moscow (MSK) - Russia', value: 'Europe/Moscow' },
    { label: 'Europe/Istanbul (TRT) - Turkey', value: 'Europe/Istanbul' },
    { label: 'Europe/Athens (EET/EEST) - Greece', value: 'Europe/Athens' },
    // Asia
    { label: 'Asia/Dubai (GST) - UAE', value: 'Asia/Dubai' },
    { label: 'Asia/Riyadh (AST) - Saudi Arabia', value: 'Asia/Riyadh' },
    { label: 'Asia/Kolkata (IST) - India', value: 'Asia/Kolkata' },
    { label: 'Asia/Karachi (PKT) - Pakistan', value: 'Asia/Karachi' },
    { label: 'Asia/Dhaka (BST) - Bangladesh', value: 'Asia/Dhaka' },
    { label: 'Asia/Colombo (IST) - Sri Lanka', value: 'Asia/Colombo' },
    { label: 'Asia/Kathmandu (NPT) - Nepal', value: 'Asia/Kathmandu' },
    { label: 'Asia/Bangkok (ICT) - Thailand', value: 'Asia/Bangkok' },
    { label: 'Asia/Singapore (SGT) - Singapore', value: 'Asia/Singapore' },
    { label: 'Asia/Kuala_Lumpur (MYT) - Malaysia', value: 'Asia/Kuala_Lumpur' },
    { label: 'Asia/Manila (PHT) - Philippines', value: 'Asia/Manila' },
    { label: 'Asia/Jakarta (WIB) - Indonesia West', value: 'Asia/Jakarta' },
    { label: 'Asia/Hong_Kong (HKT) - Hong Kong', value: 'Asia/Hong_Kong' },
    { label: 'Asia/Shanghai (CST) - China', value: 'Asia/Shanghai' },
    { label: 'Asia/Taipei (CST) - Taiwan', value: 'Asia/Taipei' },
    { label: 'Asia/Seoul (KST) - South Korea', value: 'Asia/Seoul' },
    { label: 'Asia/Tokyo (JST) - Japan', value: 'Asia/Tokyo' },
    { label: 'Asia/Jerusalem (IST) - Israel', value: 'Asia/Jerusalem' },
    { label: 'Asia/Tehran (IRST) - Iran', value: 'Asia/Tehran' },
    // Australia & Pacific
    { label: 'Australia/Sydney (AEDT/AEST) - NSW', value: 'Australia/Sydney' },
    { label: 'Australia/Melbourne (AEDT/AEST) - Victoria', value: 'Australia/Melbourne' },
    { label: 'Australia/Brisbane (AEST) - Queensland', value: 'Australia/Brisbane' },
    { label: 'Australia/Adelaide (ACDT/ACST) - South Australia', value: 'Australia/Adelaide' },
    { label: 'Australia/Perth (AWST) - Western Australia', value: 'Australia/Perth' },
    { label: 'Australia/Darwin (ACST) - Northern Territory', value: 'Australia/Darwin' },
    { label: 'Pacific/Auckland (NZDT/NZST) - New Zealand', value: 'Pacific/Auckland' },
    { label: 'Pacific/Fiji (FJT) - Fiji', value: 'Pacific/Fiji' },
    // Africa
    { label: 'Africa/Cairo (EET) - Egypt', value: 'Africa/Cairo' },
    { label: 'Africa/Johannesburg (SAST) - South Africa', value: 'Africa/Johannesburg' },
    { label: 'Africa/Lagos (WAT) - Nigeria', value: 'Africa/Lagos' },
    { label: 'Africa/Nairobi (EAT) - Kenya', value: 'Africa/Nairobi' }
  ];
  filteredTimezones = [...this.timezones];
  timezoneSearchText = '';
  showTimezoneDropdown = false;

  newEventForm = new FormGroup({
    eventName: new FormControl('', Validators.required),
    eventCategory: new FormControl('', Validators.required),
    timezone: new FormControl(Intl.DateTimeFormat().resolvedOptions().timeZone),
    startTime: new FormControl('', [Validators.required]),
    startTimeString: new FormControl(''),
    endTime: new FormControl(''),
    endTimeString: new FormControl(''),
    eventLocation: new FormControl(''),
    hostedBy: new FormControl(''),
    message: new FormControl(''),
    default_image_id: new FormControl(),
    coverImage: new FormControl(''),
    rsvp: new FormControl(false),
    defaultTab: new FormControl('photos'),
    allowBulkDownload: new FormControl(true),
    sortOrder: new FormControl('desc')
  }
    , { validators: this.validateEndTimeAfterStartTimeAndMaxDuration }
  );
  @ViewChild('picker') startTime: any;
  @ViewChild('picker') endTime: any;
  selectedCategory: any;
  isFutureEvent: boolean = false;
  eventDuration: string = '';
  filteredOptions!: Observable<string[]>;
  options: string[] = ['One', 'Two', 'Three'];

  /** Fixed category pills. "Other" reveals a free-text input. */
  readonly categoryPills: string[] = ['Wedding', 'Birthday', 'Holiday', 'Other'];
  /** Whether the "Other" pill is active (shows the custom-name input). */
  showOtherCategoryInput = false;

  coverImage: any = null;
  default_image_id: any = null;
  newFolderName: any;
  subfolders: any = [];
  isFolderDialogOpen: boolean = false;
  popupTitle: string = 'Add Folder Name';
  editFolderId: any = 0;
  showSuccessPopup: boolean = false;
  showConfirmModal: boolean = false;
  showPopup: boolean = false;
  showFullPage: boolean = false;
  confirmMessage: string = "Are you sure you want to update this event?";
  isEditable = false;
  public date!: Date;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = true;
  public enableMeridian = true;
  public minDate: any;
  public maxDate: any;
  public stepHour = 1;
  public stepMinute = 15;
  public stepSecond = 1;
  public isCreating = false;
  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
    date2: new FormControl(null, [Validators.required])
  })
  public dateControl = new FormControl(new Date(2021, 9, 4, 5, 6, 7));
  public dateControlMinMax = new FormControl(new Date());
  public listColors = ['primary', 'accent', 'warn'];

  public stepHours = [1, 2, 3, 4, 5];
  public stepMinutes = [1, 5, 10, 15, 20, 25];
  public stepSeconds = [1, 5, 10, 15, 20, 25];
  showMessage: string = "";
  originalFormValues: any;
  oldFormValues: any;
  useNow: boolean = false;
  access: any = '';
  menuOpen = false;
  openMenuIndex: number | null = null;
  menuPosition: { top: number; right: number } = { top: 0, right: 0 };
  selectedMenuGuest: any = null;
  enc_eventData: any;
  decryptedEData: any;
  encryptedEData: any;
  encryptedIData: any;
  decryptedIData: any;
  confirmAction: any;
  isBrandingEnabled: any;
  hasBrandingAccess: any;
  isPaidUser: boolean = false;

  /** Kill switches for Public Event / Event Branding / Watermarking — see environment.ts. */
  readonly env = environment;

  // ---- Gallery Settings additions: Sorting Order + Guest Uploads ----
  /** Latest-first by default; the host can flip it to oldest-first below. Saved per event via updateDefaultSortOrder. */
  currentSortOrder: string = 'desc';
  isSettingSortOrder: boolean = false;
  // Allow Guest Uploads — picks which of the two existing QR/link pairs (collaborator
  // vs viewer) is shown below. Not a saved event property, mirrors the invite dialog's
  // own checkbox: guests with the collaborator link/QR can always upload regardless.
  allowGuestUploads: boolean = true;
  guestUploadsLinkCopied: boolean = false;

  /**
   * Account-level `event_branding` feature flag, resolved from the account API.
   * Separate from `hasBrandingAccess`, which is this host's per-event grant off
   * the invite payload — both have to hold.
   */
  accountCanBrandEvents: boolean = false;

  /** Event Branding needs the account feature enabled *and* access on this event. */
  get canUseBranding(): boolean {
    return this.accountCanBrandEvents && !!this.hasBrandingAccess;
  }

  // Canva Templates section
  allTemplates: CanvaTemplate[] = [];
  filteredTemplates: CanvaTemplate[] = [];
  selectedTemplateCategory: 'all' | 'wedding' | 'birthday' = 'all';
  eventDetailsCopied: boolean = false;
  isTemplatesLoading: boolean = false;
  private templateSub?: Subscription;


  constructor(private router: Router, private eventService: EventService,
    private afAuth: AngularFireAuth, private toastService: ToastService,
    public dataService: DataService,
    private authService: AuthService,
    private encryptionService: EncryptionService,
    private platform: Platform,
    private idle: Idle,
    private location: Location,
    private keepalive: Keepalive,
    private activatedRoute: ActivatedRoute, private dialog: MatDialog,
    private versionService: VersionService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private canvaTemplateService: CanvaTemplateService) {
    this.version = this.versionService.version;

  }


  async ngOnInit() {
    this.isLoading = true;
    // Initialize branding form
    this.initBrandingForm();
    // Branding is paid-only — resolve the plan before the section can be opened
    this.fetchPlanAccess();
    // Initialize Canva templates (loads from Firestore, falls back to static list)
    this.loadTemplates();

    try {
      let inviteRes: any;
      inviteRes = localStorage.getItem('invite-info');
      this.decryptedIData = inviteRes ? this.encryptionService.decryptData(inviteRes) : null;
      // 2️⃣ Prepare eventData from inviteData
      this.inviteData = JSON.parse(this.decryptedIData || '{}');
      this.hasBrandingAccess = this.inviteData.hasBrandingAccess;
      // console.log('inviteData:', this.inviteData); //__CONSOLE_LOG__

      this.eventData = {
        ...this.inviteData,
        eventName: this.inviteData.name,
        eventCategory: this.inviteData.category,
        start_time: this.inviteData.start_time,
        end_time: this.inviteData.scheduled_end_time,
        scheduled_end_time: this.inviteData.scheduled_end_time,
        timezone: this.inviteData.timezone,
        rsvp: this.inviteData.rsvp === 'yes',
        event_location: this.inviteData.event_location,
        message: this.inviteData.message,
        hostName: this.inviteData.host_name,
        coverImage: localStorage.getItem('coverImage'),
      };

      this.eventId = this.inviteData.eventId;
      if (this.eventData.hostName == null || this.eventData.hostName === undefined && this.inviteData.isHost == true) {
        this.eventData.hostName = this.eventData.user_name;
      }
      // 3️⃣ Fetch invite history
      // Now fetch fresh invite-info from server before finishing
      const eventIdToFetch = localStorage.getItem('eventId');
      // console.log('🔄 Fetching fresh invite data for eventId:', eventIdToFetch); //__CONSOLE_LOG__

      this.eventService.getTotalMediaCount(eventIdToFetch).subscribe({
        next: (res) => {
          // console.log('✅ Fresh invite data received:', res); //__CONSOLE_LOG__
          if (res) {
            // Store the fresh data
            this.inviteData = res;
            this.hasBrandingAccess = this.inviteData.hasBrandingAccess;
            // Encrypt and save to localStorage for next time
            this.encryptedIData = this.encryptionService.encryptData(JSON.stringify(res));
            localStorage.setItem('invite-info', this.encryptedIData);
            // Also update inviteData so event-detail reads fresh values
            localStorage.setItem('inviteData', this.encryptedIData);

            // Set default tab value from API response
            if (res.default_tab) {
              this.newEventForm.patchValue({
                defaultTab: res.default_tab
              });
            }

            // Set allow bulk download value from API response
            if (res.bulk_download !== undefined) {
              this.newEventForm.patchValue({
                allowBulkDownload: res.bulk_download
              });
            }

            // Set sorting order from API response — per-event, defaults to
            // latest-first when the event has never had one saved. pwa_get_media_count
            // now returns `sorting_order` directly; prefer it over the older
            // `default_sort_order` key for any response that hasn't been updated yet.
            this.currentSortOrder = res.sorting_order || res.default_sort_order || 'desc';
            this.newEventForm.patchValue({
              sortOrder: this.currentSortOrder
            });

            // Update originalFormValues to prevent "no data to update" on next save
            this.originalFormValues = { ...this.newEventForm.value };

            // console.log('✅ invite-info and inviteData updated in localStorage'); //__CONSOLE_LOG__
          }

        },
        error: (err) => {
          // console.error('❌ Error fetching fresh invite data:', err); //__CONSOLE_LOG__

        },
      });


      const historyRes: any = await firstValueFrom(this.eventService.getInviteHistory(this.eventId));
      if (historyRes?.totalFiles != null) {
        this.eventTotalFiles = historyRes.totalFiles;
      }
      if (historyRes?.storage) {
        this.eventStorageBytes = historyRes.storage.storage_bytes ?? 0;
        if (this.eventStorageBytes > 0) {
          this.eventStorage = this.formatStorageBytes(this.eventStorageBytes);
        }
        this.eventImageCount = historyRes.storage.image_count ?? 0;
        this.eventVideoCount = historyRes.storage.video_count ?? 0;
      }
      if (historyRes?.collaborators) {
        this.collaborators = historyRes.collaborators
          .filter((user: any) => !user.exited)
          .map((c: any) => ({
            ...c,
            rsvpClass: this.getRsvpClass(c.rsvp),
            rsvpColor: this.getRsvpColor(c.rsvp),
            rsvpImage: this.getUserIcon(c.digitalRSVP),
          }));
        this.filteredGuests = [...this.collaborators];
      }

      // Check for pending host transition request from API response
      if (historyRes?.hostTransitions?.length && this.isHost === 'true') {
        // console.log('[HostTransfer] host_transition data:', historyRes.hostTransitions); //__CONSOLE_LOG__
        // console.log('[HostTransfer] collaborators user_ids:', this.collaborators.map((c: any) //__CONSOLE_LOG__ => c.user_id));
        const pending = historyRes.hostTransitions.find(
          (t: any) => t.status === 'pending'
        );
        if (pending) {
          // API may return snake_case (requested_host_id) or camelCase (requestedHostId)
          const rawId = pending.requested_host_id ?? pending.requestedHostId;
          this.hostTransferPendingUserId = rawId?.toString() ?? null;
          this.hostTransferTransitionId = pending.transitionId?.toString() ?? null;
          // console.log('[HostTransfer] pending entry:', pending, '→ hostTransferPendingUserId:', this.hostTransferPendingUserId); //__CONSOLE_LOG__
        }
      }

      // 4️⃣ Set flags
      this.isAnyLive = localStorage.getItem('isAnyLive') || 'false';
      this.isHost = localStorage.getItem('isHost')?.toString();
      this.isScheduled = localStorage.getItem('isScheduled')?.toString();
      this.isPast = !!this.eventData.end_time;

      // Warm the invite/QR data so the "Share Event" dialog opens instantly.
      if (this.isHost === true || this.isHost === 'true') {
        this.prefetchEventQR();
      }

      // 5️⃣ Initialize form — format using event timezone so UI shows correct zone times
      const toMs = (v: any) => {
        if (v == null) return null;

        // If it's already a Date object
        if (v instanceof Date) return v.getTime();

        // If it's a string (ISO date), parse it
        if (typeof v === 'string') {
          const parsed = new Date(v);
          return isNaN(parsed.getTime()) ? null : parsed.getTime();
        }

        // If it's a number (timestamp)
        const n = Number(v);
        if (isNaN(n)) return null;
        // If less than year 2000 in milliseconds, assume it's in seconds
        return n < 946684800000 ? n * 1000 : n;
      };

      const timezoneValue = this.eventData.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      const startMs = toMs(this.eventData.start_time);
      const endMs = toMs(this.eventData.end_time || this.eventData.scheduled_end_time);

      // console.log('Loading event - start_time:', this.eventData.start_time, 'startMs:', startMs); //__CONSOLE_LOG__
      // console.log('Loading event - end_time:', this.eventData.end_time, 'endMs:', endMs); //__CONSOLE_LOG__
      // console.log('Loading event - timezone:', timezoneValue); //__CONSOLE_LOG__

      const formatDateInZone = (ms: number | null, zone: string) => {
        if (!ms) return '';
        return DateTime.fromMillis(ms, { zone }).toFormat('yyyy-MM-dd');
      };

      const formatTimeInZone = (ms: number | null, zone: string) => {
        if (!ms) return '';
        return DateTime.fromMillis(ms, { zone }).toFormat('HH:mm');
      };

      this.newEventForm.patchValue({
        eventName: this.eventData.eventName || '',
        eventCategory: this.eventData.eventCategory || '',
        timezone: timezoneValue,
        startTime: formatDateInZone(startMs, timezoneValue),
        startTimeString: formatTimeInZone(startMs, timezoneValue),
        endTime: formatDateInZone(endMs, timezoneValue),
        endTimeString: formatTimeInZone(endMs, timezoneValue),
        hostedBy: this.eventData.hostName || '',
        eventLocation: this.eventData.event_location || '',
        message: this.eventData.message || '',
        rsvp: this.eventData.rsvp,
      });

      // Reflect the loaded category on the pills (open "Other" input for custom values).
      this.syncCategoryPillState();

      // console.log('Form values after patch:', this.newEventForm.value); //__CONSOLE_LOG__

      // 6️⃣ Cover image
      this.coverImage = this.eventData.coverImage || null;
      if (localStorage.getItem('editEvent')) {
        this.coverImage = localStorage.getItem('cover') || localStorage.getItem('default_image_url') || this.coverImage;
        this.default_image_id = localStorage.getItem('default_image') || this.default_image_id;
      }

      // 7️⃣ Autocomplete for eventCategory
      this.filteredOptions = this.newEventForm.controls.eventCategory.valueChanges.pipe(
        startWith(''),
        map(value => {
          const name = typeof value === 'string' ? value : value;
          return name ? this._filter(name) : this.options.slice();
        })
      );

      // 8️⃣ Duration calculations
      this.calculateDuration();
      this.newEventForm.get('startTime')?.valueChanges.subscribe(() => this.calculateDuration());
      this.newEventForm.get('endTime')?.valueChanges.subscribe(() => this.calculateDuration());

      // 9️⃣ Subfolders
      this.subfolders = JSON.parse(localStorage.getItem('event_subfolders') || '[]');
      this.subfolders.forEach((el: any) => { if (el.id) el.subfolder_id = el.id; });

      // 🔟 RSVP location validation
      this.newEventForm.get('rsvp')?.valueChanges.subscribe((rsvpSelected: boolean | null) => {
        if (rsvpSelected === null) return;
        const locationControl = this.newEventForm.get('eventLocation');
        rsvpSelected ? locationControl?.setValidators([Validators.required]) : locationControl?.clearValidators();
        locationControl?.updateValueAndValidity();
      });

      // 1️⃣1️⃣ Save original form values & disable form
      this.originalFormValues = { ...this.newEventForm.value };
      this.oldFormValues = this.newEventForm.getRawValue();
      this.newEventForm.disable();

    } catch (err) {
      // console.error('Error in ngOnInit:', err); //__CONSOLE_LOG__ //__CONSOLE_LOG__
      // this.router.navigateByUrl('/home');
    } finally {
      this.isLoading = false;
    }
  }
  // async ngOnInit() {
  //   this.isLoading = true;
  //  // this.access = localStorage.getItem('access')?.toString();
  //   //console.log(this.access);

  //   await (this.eventService.getInviteInfo()).subscribe({
  //     next: (res: any) => {
  //       console.log(res);
  //       if (res) {

  //         this.encryptedIData = this.encryptionService.encryptData(JSON.stringify(res));
  //         localStorage.setItem('inviteData', this.encryptedIData);
  //         this.decryptedIData = this.encryptionService.decryptData(this.encryptedIData);
  //         this.inviteData = JSON.parse(this.decryptedIData);
  //         console.log(this.inviteData);
  //        let access = this.inviteData.restricted == 1 ? 'restricted' : 'null';

  //       }
  //     },
  //     error: (err) => {
  //       console.error(err);
  //     },
  //   });

  //   if (!localStorage.getItem('inviteData') && !localStorage.getItem('eventData')) {
  //     this.router.navigateByUrl('/home');
  //   }

  //   let inviteData: any; // Class-level property
  //   let eventData: any; // Class-level property

  //   // if (localStorage.getItem('inviteData')) {
  //   //   this.encryptedIData = localStorage.getItem('inviteData');
  //   //   inviteData = this.encryptionService.decryptData(this.encryptedIData);
  //   //   this.inviteData = JSON.parse(inviteData);
  //   //   console.log(this.inviteData);
  //   // }

  //   // if (localStorage.getItem('eventData')) {
  //   //   this.encryptedEData = localStorage.getItem('eventData');
  //   //   eventData = this.encryptionService.decryptData(this.encryptedEData);
  //   //   this.eventData = JSON.parse(eventData);
  //   //   console.log(this.eventData);
  //   // }

  //   if (eventData == null || eventData == undefined) {
  //     this.eventData = this.inviteData; // or set it to any default structure you expect
  //     this.eventData.eventName = this.inviteData.event_name;
  //     this.eventData.eventCategory = this.inviteData.category_name;
  //     this.eventData.start_time = this.inviteData.start_time * 1000;
  //     this.eventData.end_time = this.inviteData.scheduled_end_time * 1000;
  //     this.eventData.scheduled_end_time = this.inviteData.scheduled_end_time * 1000;
  //     this.eventData.event_location = this.inviteData.event_location;
  //     this.eventData.rsvp = this.inviteData.rsvp == 'yes' ? true : false;
  //     this.eventData.hostName = this.inviteData.host_name;
  //     this.eventData.message = this.inviteData.message;
  //     this.eventData.coverImage = this.inviteData.coverImage;
  //     this.eventData.default_image_id = this.inviteData.default_image_id;
  //     this.eventData.eventId = this.inviteData.eventId;
  //     this.eventData.hostImage = this.inviteData.hostImage;
  //   }

  //   this.eventId = this.eventData.eventId;

  //   this.isMobile;
  //   this.isLoading = true;
  //   this.isAnyLive = localStorage.getItem('isAnyLive') ? localStorage.getItem('isAnyLive') : 'false';
  //   console.log(this.isMobile);

  //   this.isHost = localStorage.getItem('isHost')?.toString();
  //   this.isScheduled = localStorage.getItem('isScheduled')?.toString();
  //   (this.eventService.getInviteHistory(this.eventId)).subscribe({
  //     next: (res: any) => {
  //       this.isLoading = false;
  //       console.log(res);
  //       if (res && res.collaborators) {
  //         // Process collaborators to add the class and color information
  //         this.collaborators = res.collaborators.filter((user: { exited: boolean; }) => user.exited == false).map((collaborator: any) => ({
  //           ...collaborator,
  //           rsvpClass: this.getRsvpClass(collaborator.rsvp),
  //           rsvpColor: this.getRsvpColor(collaborator.rsvp),
  //           rsvpImage: this.getUserIcon(collaborator.digitalRSVP)
  //         }));
  //         this.filteredGuests = [...this.collaborators];
  //         // console.log(this.collaborators);
  //         //this.isGuestLoading = false;
  //       }
  //     },
  //     error: (err) => {
  //       console.error(err);
  //     },
  //   });

  //   if (this.eventData.end_time != null) {
  //     this.isPast = true;
  //     console.log('past event: ', this.isPast);
  //   }

  //   // Set the form values
  //   this.newEventForm.patchValue({
  //     eventName: this.eventData.eventName || '',
  //     eventCategory: this.eventData.categoryName || this.eventData.category_name || '',
  //     startTime: this.eventData.start_time ? new Date(this.eventData.start_time) : null,
  //     endTime: this.eventData.end_time
  //       ? new Date(this.eventData.end_time)
  //       : this.eventData.scheduled_end_time
  //         ? new Date(this.eventData.scheduled_end_time)
  //         : null,
  //     hostedBy: this.eventData.hostName || '',
  //     eventLocation: this.eventData.event_location || '',
  //     message: this.eventData.message || '',
  //     rsvp: this.eventData.rsvp,
  //   });
  //   console.log(this.newEventForm.value);


  //   // Set the cover image if it exists
  //   this.coverImage = this.eventData.coverImage || null;
  //   if (localStorage.getItem('editEvent') && localStorage.getItem('default_image_url')) {
  //     this.coverImage = localStorage.getItem('default_image_url');
  //     this.default_image_id = localStorage.getItem('default_image');

  //   }
  //   if (localStorage.getItem('editEvent') && localStorage.getItem('cover')) {
  //     this.coverImage = localStorage.getItem('cover');
  //   }

  //   this.filteredOptions = this.newEventForm.controls.eventCategory.valueChanges.pipe(
  //     startWith(''),
  //     map(value => {
  //       const name = typeof value === 'string' ? value : value;
  //       return name ? this._filter(name as string) : this.options.slice();
  //     }),
  //   );

  //   this.calculateDuration();
  //   this.newEventForm.get('startTime')?.valueChanges.subscribe(() => this.calculateDuration());
  //   this.newEventForm.get('endTime')?.valueChanges.subscribe(() => this.calculateDuration());

  //   this.subfolders = localStorage.getItem('event_subfolders') ? JSON.parse(localStorage.getItem('event_subfolders') || '') : [];
  //   this.subfolders.forEach((element: any) => {
  //     if (element.id) {
  //       element.subfolder_id = element.id;
  //     }

  //   });
  //   console.log(this.subfolders);
  //   this.newEventForm.get('rsvp')?.valueChanges.subscribe((rsvpSelected: boolean | null) => {
  //     if (rsvpSelected === null) return;
  //     const locationControl = this.newEventForm.get('eventLocation');
  //     if (rsvpSelected) {
  //       locationControl?.setValidators([Validators.required]);
  //     } else {
  //       locationControl?.clearValidators();
  //     }
  //     locationControl?.updateValueAndValidity();
  //   });
  //   this.originalFormValues = { ...this.newEventForm.value };
  //   this.oldFormValues = this.newEventForm.getRawValue();
  //   this.newEventForm.disable();
  // }

  private _filter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();
    return this.options.filter(option => option.toString().toLowerCase().includes(filterValue));
  }

  goToEditPage(): void {
    this.router.navigate(['/edit-event']); // Replace with your route
  }

  goToPastEditPage(): void {
    this.router.navigate(['/edit-past-event']); // Replace with your route
  }

  filterGuests(rsvp: 'yes' | 'no' | 'all' | 'maybe'): void {
    this.filteredGuests = [];
    this.selectedFilter = rsvp;
    if (rsvp === 'all') {
      this.filteredGuests = [...this.collaborators];
    } else {
      this.filteredGuests = this.collaborators.filter((g: { digitalRSVP: string }) => g.digitalRSVP === rsvp);
    }
  }

  get allCount(): number {
    return this.collaborators.length;
  }

  get yesCount(): number {
    return this.collaborators.filter((g: { digitalRSVP: string }) => g.digitalRSVP === 'yes').length;
  }

  get noCount(): number {
    return this.collaborators.filter((g: { digitalRSVP: string }) => g.digitalRSVP === 'no').length;
  }

  get maybeCount(): number {
    return this.collaborators.filter((g: { digitalRSVP: string }) => g.digitalRSVP === 'maybe').length;
  }

  goTo(path: string) {
    this.router.navigate([`/${path}`]);
  }

  private async fetchPlanAccess(): Promise<void> {
    try {
      (await this.eventService.getMyAccountDetails()).subscribe({
        next: (res: any) => {
          // ApiCacheService seeds every subscriber with null before the response
          // lands — resolving against that would flip the section off and back on.
          if (!res) return;
          this.isPaidUser = isPaidPlanName(res?.plan?.plan_name);
          this.accountCanBrandEvents = isFeatureEnabled(
            res.features,
            FEATURE_EVENT_BRANDING,
            () => this.isPaidUser && res.account?.event_branding === 1
          );
        },
        error: () => {
          this.isPaidUser = false;
          this.accountCanBrandEvents = false;
        },
      });
    } catch {
      this.isPaidUser = false;
      this.accountCanBrandEvents = false;
    }
  }

  showBranding() {
    if (!this.canUseBranding) {
      return;
    }
    if (this.isMobile) {
      this.router.navigate(['/event-branding']);
    } else {
      this.currentSection = 5;
      // Load branding data when section is shown
      this.loadBrandingData();
    }
  }

  showTemplates() {
    this.currentSection = 6;
    if (this.isMobile) {
      this.showFullPage = true;
    }
    // Sync from Canva then reload every time section is opened
    this.templateSub?.unsubscribe();
    this.isTemplatesLoading = true;
    this.templateSub = this.canvaTemplateService.syncThenLoad().subscribe({
      next: (templates) => {
        this.allTemplates = templates;
        this.filterTemplates(this.selectedTemplateCategory);
        this.isTemplatesLoading = false;
      },
      error: () => {
        this.allTemplates = CANVA_TEMPLATES;
        this.filterTemplates(this.selectedTemplateCategory);
        this.isTemplatesLoading = false;
      },
    });
  }

  loadTemplates() {
    this.isTemplatesLoading = true;
    this.templateSub = this.canvaTemplateService.syncThenLoad().subscribe({
      next: (templates) => {
        this.allTemplates = templates;
        this.filterTemplates(this.selectedTemplateCategory);
        this.isTemplatesLoading = false;
      },
      error: () => {
        this.allTemplates = CANVA_TEMPLATES;
        this.filterTemplates(this.selectedTemplateCategory);
        this.isTemplatesLoading = false;
      },
    });
  }

  filterTemplates(category: 'all' | 'wedding' | 'birthday') {
    this.selectedTemplateCategory = category;
    this.filteredTemplates = category === 'all'
      ? [...this.allTemplates]
      : this.allTemplates.filter(t => t.category === category);
  }

  openCanvaTemplate(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  ngOnDestroy() {
    this.templateSub?.unsubscribe();
  }

  copyEventDetails() {
    const lines: string[] = [];
    if (this.inviteData?.name) {
      lines.push(`Event: ${this.inviteData.name}`);
    }
    if (this.inviteData?.start_time) {
      const startDate = new Date(Number(this.inviteData.start_time) < 946684800000
        ? Number(this.inviteData.start_time) * 1000
        : Number(this.inviteData.start_time));
      lines.push(`Date: ${startDate.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}`);
      lines.push(`Time: ${startDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}`);
    }
    if (this.inviteData?.scheduled_end_time) {
      const endDate = new Date(Number(this.inviteData.scheduled_end_time) < 946684800000
        ? Number(this.inviteData.scheduled_end_time) * 1000
        : Number(this.inviteData.scheduled_end_time));
      lines.push(`Ends: ${endDate.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} at ${endDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}`);
    }
    if (this.inviteData?.event_location) {
      lines.push(`Location: ${this.inviteData.event_location}`);
    }
    if (this.inviteData?.host_name) {
      lines.push(`Hosted by: ${this.inviteData.host_name}`);
    }
    if (this.inviteData?.message) {
      lines.push(`\n${this.inviteData.message}`);
    }
    const text = lines.join('\n');
    navigator.clipboard.writeText(text).then(() => {
      this.eventDetailsCopied = true;
      setTimeout(() => { this.eventDetailsCopied = false; }, 2000);
    }).catch(() => {
      // Fallback for browsers without clipboard API
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.eventDetailsCopied = true;
      setTimeout(() => { this.eventDetailsCopied = false; }, 2000);
    });
  }

  changeHost(userId: string, guest: any) {
    if (this.isHost !== true && this.isHost !== 'true') return;
    this.selectedGuestForHostTransfer = guest;
    this.showChangeHostModal = true;
    this.openMenuIndex = null;
  }

  cancelHostTransferModal() {
    this.showChangeHostModal = false;
    this.hostTransferSent = false;
    this.selectedGuestForHostTransfer = null;
  }

  openEventAlbum() {
    this.cancelHostTransferModal();
    this.goBack();
  }

  async sendHostTransferRequest() {
    this.userId = localStorage.getItem('u') || '';
    if (!this.selectedGuestForHostTransfer) return;
    this.isHostTransferLoading = true;
    try {
      const observable = await this.eventService.requestHostTransition(
        this.eventId,
        this.userId,
        this.selectedGuestForHostTransfer.user_id,
        this.eventData?.eventName || '',
        this.eventData?.hostName || ''
      );
      observable.subscribe({
        next: (res: any) => {
          this.hostTransferPendingUserId = this.selectedGuestForHostTransfer.user_id?.toString();
          this.hostTransferTransitionId = res?.transitionId?.toString() ?? res?.transition_request_id?.toString() ?? null;
          this.hostTransferSent = true;
          this.isHostTransferLoading = false;
        },
        error: (err: any) => {
          // console.error('Error sending host transfer request', err); //__CONSOLE_LOG__
          this.isHostTransferLoading = false;
        }
      });
    } catch (err) {
      // console.error(err); //__CONSOLE_LOG__
      this.isHostTransferLoading = false;
    }
  }

  cancelHostTransfer(requested_host_id: string) {
    if (!this.hostTransferTransitionId) {
      this.hostTransferPendingUserId = null;
      return;
    }
    this.userId = localStorage.getItem('u') || ''; //host_id
    this.eventService.respondToHostTransition(
      this.eventId,
      requested_host_id,
       this.userId,
      this.eventData?.eventName || '',
      this.eventData?.hostName || '',
      this.hostTransferTransitionId,
      'cancelled'
    ).then(obs => {
      obs?.subscribe({
        next: () => {
          this.hostTransferPendingUserId = null;
          this.hostTransferTransitionId = null;
        },
        error: (err: any) => console.error('Cancel host transfer failed', err),
      });
    }).catch(err => console.error(err));
  }

  // Persist the getEventQR payload the invite dialog reads from localStorage.
  private storeEventQrData(res: any): void {
    localStorage.setItem('qrImage', res.qrCode);
    localStorage.setItem('eventStatus', res.eventStatus);
    localStorage.setItem('name', res.event_name);
    localStorage.setItem('viewer_qrImage', res.viewer_qrCode);
    localStorage.setItem('myphotos_viewer_qrCode', res.myphotos_viewer_qrCode);
    localStorage.setItem('myphotos_collab_qrCode', res.myphotos_collab_qrCode);
    localStorage.setItem('web_qrImage', res.web_qrCode);
    localStorage.setItem('web_viewer_qrImage', res.web_viewer_qrCode);
    localStorage.setItem('event_hash', res.hash);
    localStorage.setItem('viewer_hash', res.viewer_hash);
    if (this.inviteData.isHost) {
      localStorage.setItem('u', this.eventData.host_id);
    }
    localStorage.setItem('e', this.eventData.eventId);
  }

  // Warm the QR/invite data on load so the Share dialog opens instantly.
  // Silent on failure — inviteUsers() retries with a loader.
  prefetchEventQR(): void {
    if (this.qrPrefetchDone || this.qrPrefetchInFlight) return;
    if (!this.eventData?.eventId) return;
    this.qrPrefetchInFlight = true;
    this.eventService.getEventQR(this.eventData.eventId).subscribe({
      next: (res: any) => {
        this.qrPrefetchInFlight = false;
        if (res) {
          this.storeEventQrData(res);
          this.qrPrefetchDone = true;
        }
      },
      error: () => {
        this.qrPrefetchInFlight = false;
      }
    });
  }

  inviteUsers() {
    // console.log(this.eventData , this.eventId); //__CONSOLE_LOG__

    // If prefetched (on load), open instantly without the round-trip.
    if (this.qrPrefetchDone) {
      this.openInviteDialog();
      return;
    }

    this.isLoading = true;
    ((this.eventService.getEventQR(this.eventData.eventId))).subscribe({
      next: (res: any) => {
        // console.log(res); //__CONSOLE_LOG__
        if (res) {
          this.storeEventQrData(res);
          this.qrPrefetchDone = true;

          // Keep loader showing until dialog opens
          setTimeout(() => {
            this.isLoading = false;
            this.openInviteDialog();
          }, 100);
          // this.router.navigate(['/invite-users'], { queryParams: { inviteCode } });
          //  this.router.navigateByUrl('/invite-users');
        }

      }
    });

  }

  cancel() {
    if (this.isEditable) {
      // Reset form to original values and disable editing
      this.newEventForm.patchValue(this.originalFormValues);
      this.isEditable = false;
      this.newEventForm.disable();
    } else {
      this.goBack();
    }
  }

  async generateMessage() {
    this.isCreating = true;
    (await (this.eventService.generateAIresponse('create-event', this.newEventForm.value.eventName))).subscribe({
      next: (res: any) => {

        // console.log(res); //__CONSOLE_LOG__
        if (res) {
          this.isCreating = false;
          this.newEventForm.patchValue({ message: res.result.body || "" });
        }
      },
      error: (err) => {
        this.isCreating = false;
        // console.error(err); //__CONSOLE_LOG__
      },
    });

  }

  get formControls() {
    return this.newEventForm.controls;
  }


  onStartTimeChange(event: any) {
    const selectedTime = new Date(event.value);
    const now = new Date();

    now.setSeconds(0, 0); // Ignore milliseconds for accurate comparison
    this.newEventForm.controls['startTime'].setErrors(null);
    this.checkFutureEvent(selectedTime);

    // Update min End Time dynamically
    this.newEventForm.controls['endTime'].setValidators([
      Validators.required,
      (control) => control.value && new Date(control.value) <= selectedTime ? { endBeforeStart: true } : null
    ]);
    this.newEventForm.controls['endTime'].updateValueAndValidity();
  }

  formatTimeToString(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  formatDateToString(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onTimezoneChange() {
    // Timezone changed - no need to convert dates/times
    // console.log('Timezone changed to:', this.newEventForm.get('timezone') //__CONSOLE_LOG__?.value);
    // Clear the search text when a timezone is selected from dropdown
    this.timezoneSearchText = '';
    this.filteredTimezones = [...this.timezones];
    this.showTimezoneDropdown = false;
  }

  filterTimezones(searchText: string) {
    this.timezoneSearchText = searchText;
    if (!searchText || searchText.trim() === '') {
      this.filteredTimezones = [...this.timezones];
      this.showTimezoneDropdown = false;
      return;
    }
    const search = searchText.toLowerCase();
    this.filteredTimezones = this.timezones.filter(tz =>
      tz.label.toLowerCase().includes(search) ||
      tz.value.toLowerCase().includes(search)
    );

    // Show dropdown with filtered results
    this.showTimezoneDropdown = this.filteredTimezones.length > 0 && this.isEditable;
    // console.log('Show dropdown:', this.showTimezoneDropdown, 'Filtered count:', this.filteredTimezones.length, 'Is editable:', this.isEditable); //__CONSOLE_LOG__

    // Auto-select timezone when searching
    if (this.filteredTimezones.length > 0 && this.isEditable) {
      // If exactly one match, auto-select it
      if (this.filteredTimezones.length === 1) {
        this.newEventForm.patchValue({ timezone: this.filteredTimezones[0].value });
        // console.log('Auto-selected timezone:', this.filteredTimezones[0].value); //__CONSOLE_LOG__
      }
      // If multiple matches, check if any label ends with the search term (e.g., "- India")
      else {
        const exactMatch = this.filteredTimezones.find(tz =>
          tz.label.toLowerCase().endsWith('- ' + search) ||
          tz.label.toLowerCase().includes('- ' + search + ' ')
        );
        if (exactMatch) {
          this.newEventForm.patchValue({ timezone: exactMatch.value });
          // console.log('Auto-selected exact match timezone:', exactMatch.value); //__CONSOLE_LOG__
        }
      }
    }
  }

  selectTimezone(timezone: any) {
    this.newEventForm.patchValue({ timezone: timezone.value });
    this.timezoneSearchText = '';
    this.filteredTimezones = [...this.timezones];
    this.showTimezoneDropdown = false;
    // console.log('Selected timezone:', timezone.value); //__CONSOLE_LOG__
  }

  onTimezoneInputFocus() {
    if (this.timezoneSearchText && this.filteredTimezones.length > 0 && this.isEditable) {
      this.showTimezoneDropdown = true;
    }
  }

  closeTimezoneDropdown() {
    setTimeout(() => {
      this.showTimezoneDropdown = false;
    }, 200);
  }

  getSelectedTimezoneLabel(): string {
    const currentValue = this.newEventForm.get('timezone')?.value;
    const selected = this.timezones.find(tz => tz.value === currentValue);
    return selected ? selected.label : 'Select timezone';
  }

  checkFutureEvent(startTime: Date) {
    const now = new Date();
    this.isFutureEvent = startTime > now;
  }

  endAfterStartValidator(group: AbstractControl): ValidationErrors | null {
    const start = new Date(group.get('startTime')?.value);
    const end = new Date(group.value.endTime);
    const hostedBy = group.get('hostedBy')?.value;

    const now = new Date();

    // Check if end is after start
    if (start && end && new Date(end) <= new Date(start)) {
      return { endBeforeStart: true };
    }
    // Check if hostedBy is required when startTime is in future
    if (start && new Date(start) > now && !hostedBy) {
      return { hostedByRequired: true };
    }

    return null;
    //return end <= start ? { endBeforeStart: true } : null;
  }


  onFilterOptionSelected(optionSelected: any) {
    this.selectedCategory = optionSelected.option.value;
    // console.log('optionSelected : ', optionSelected.option.value); //__CONSOLE_LOG__
  }

  /** Fixed pills (excluding "Other") that map directly to a category value. */
  private get fixedCategoryValues(): string[] {
    return this.categoryPills.filter(p => p !== 'Other');
  }

  /** True if the given pill is the currently active selection. */
  isPillSelected(pill: string): boolean {
    const value = (this.newEventForm.controls.eventCategory.value || '').trim();
    if (pill === 'Other') {
      return this.showOtherCategoryInput;
    }
    return !this.showOtherCategoryInput && value.toLowerCase() === pill.toLowerCase();
  }

  /** Handle a pill click: fixed pills set the value directly; "Other" reveals the input. */
  selectCategoryPill(pill: string): void {
    const control = this.newEventForm.controls.eventCategory;
    if (pill === 'Other') {
      this.showOtherCategoryInput = true;
      // Clear any fixed value so the user types a fresh custom name.
      if (this.fixedCategoryValues.some(v => v.toLowerCase() === (control.value || '').toLowerCase())) {
        control.setValue('');
      }
    } else {
      this.showOtherCategoryInput = false;
      control.setValue(pill);
    }
    control.markAsTouched();
    control.markAsDirty();
  }

  /** Show the "Other" input if an existing category isn't one of the fixed pills. */
  private syncCategoryPillState(): void {
    const value = (this.newEventForm.controls.eventCategory.value || '').trim();
    this.showOtherCategoryInput =
      !!value && !this.fixedCategoryValues.some(v => v.toLowerCase() === value.toLowerCase());
  }

    openInviteDialog() {
      if (this.env.features.newInviteDesign) {
        openInviteShareDialog(this.dialog, {
          eventId: this.eventId,
          eventName: this.newEventForm.value.eventName || this.eventData?.eventName || '',
          surface: 'update_event',
          mode: 're-invite',
          coverImageUrl: this.coverImage || '',
          hostName: this.newEventForm.value.hostedBy || this.eventData?.hostName || '',
          eventStartTime: this.newEventForm.value.startTime || this.eventData?.start_time,
        });
        return;
      }

      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        this.router.navigate(['/invite-guests']); // Or show as route
      } else {
        this.dialog.open(InviteDialogComponent, {
        width: '440px',
        maxWidth: '95vw',
        height: 'auto',
        maxHeight: '92vh',
        backdropClass: 'custom-backdrop',
        panelClass: 'custom-dialog'
      });
    }
  }

  async getCategories() {
    try {
      const response = await (await this.eventService.getAllCategories()).toPromise();
      this.options = response;
    } catch (error) {
      // console.error(error); //__CONSOLE_LOG__
    }
  }

  changeCover() {
    localStorage.setItem('editEvent', 'true');
    this.openCoverPopup();
  }

  openCoverPopup() {
    this.dialog.open(CoverImageComponent, {
      width: '500px',
      //   height: '80vh',
      backdropClass: 'secondary-backdrop',
      panelClass: 'cover-dialog',
      hasBackdrop: true
    }).afterClosed().subscribe(async (result) => {
      if (localStorage.getItem('cover')) {
        this.coverImage = localStorage.getItem('cover');
      }
      else if (localStorage.getItem('default_image_url')) {
        this.coverImage = localStorage.getItem('default_image_url');
        this.default_image_id = localStorage.getItem('default_image');
      }
      localStorage.setItem('coverImage', this.coverImage);
    });
  }

  formatStorageBytes(bytes: number): string {
    if (!bytes || bytes <= 0) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) {
      return parseFloat((bytes / 1024).toFixed(2)) + ' KB';
    }
    if (bytes < 1024 * 1024 * 1024) {
      return parseFloat((bytes / (1024 * 1024)).toFixed(2)) + ' MB';
    }
    return parseFloat((bytes / (1024 * 1024 * 1024)).toFixed(2)) + ' GB';
  }

  getUserIcon(userType: string): string {
    // console.log(userType) //__CONSOLE_LOG__
    switch (userType) {
      case 'yes': return 'assets/icon/noun-collaborate.png';
      case 'maybe': return 'assets/icon/noun-view.png';
      case 'no': return 'assets/icon/noun-delete.png';
      default: return 'assets/icon/noun-view.png';
    }
  }

  getRsvpClass(rsvpStatus: string): string {
    switch (rsvpStatus) {
      case 'yes': return 'rsvp-yes';
      case 'no': return 'rsvp-no';
      case 'maybe': return 'rsvp-maybe';
      default: return '';
    }
  }

  getRsvpColor(rsvpStatus: string): string {
    switch (rsvpStatus) {
      case 'yes': return 'green';
      case 'no': return 'red';
      case 'maybe': return 'orange';
      default: return 'black'; // Default color
    }
  }

  private getNextQuarterHour(): Date {
    const now = new Date();
    const minutes = now.getMinutes();
    const nextQuarter = Math.ceil((minutes + 1) / 15) * 15;
    now.setMinutes(nextQuarter, 0, 0);
    return now;
  }

  private getDefaultEndTime(): Date {
    let start = this.getNextQuarterHour();
    return addMinutes(start, 15);
  }

  calculateDuration(): void {
    const startDateStr = this.newEventForm.get('startTime')?.value;
    const startTimeStr = this.newEventForm.get('startTimeString')?.value;
    const endDateStr = this.newEventForm.get('endTime')?.value;
    const endTimeStr = this.newEventForm.get('endTimeString')?.value;

    if (!startDateStr || !startTimeStr || !endDateStr || !endTimeStr) {
      this.eventDuration = '';
      return;
    }

    // Combine date and time strings to create full datetime
    const start = new Date(`${startDateStr}T${startTimeStr}`);
    const end = new Date(`${endDateStr}T${endTimeStr}`);

    if (start && end && end > start) {
      const durationMs = end.getTime() - start.getTime();
      const days = Math.floor(durationMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor((durationMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

      let durationStr = '';
      if (days > 0) {
        durationStr += `${days} day${days > 1 ? 's' : ''}, `;
      }
      if (hours > 0) {
        durationStr += `${hours} hour${hours > 1 ? 's' : ''}, `;
      }
      if (minutes > 0) {
        durationStr += `${minutes} minute${minutes > 1 ? 's' : ''}`;
      }

      // Remove trailing comma and space if present
      durationStr = durationStr.trim().replace(/,\s*$/, '');

      this.eventDuration = durationStr;
    } else {
      this.eventDuration = '';
    }
  }
  get isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  decrementSection() {
    if (this.currentSection > 0) {
      this.currentSection--;
    }
  }


  toggleEdit() {
    this.isEditable = !this.isEditable;

    if (this.isEditable) {
      this.newEventForm.enable();
    } else {
      this.newEventForm.disable();
    }
  }

  async addSubfolder() {
    if (this.newFolderName.trim() == 'Others' || this.newFolderName.trim() == 'others') {
      alert('Please choose a different folder name.');
      this.newFolderName = '';
      return;
    }
    if (this.subfolders.length == 10) {
      alert('Maximum folder limit is 10.');
      this.newFolderName = '';
      return;
    }
    // console.log(this.subfolders); //__CONSOLE_LOG__

    // if (this.subfolders.some((item: { subfolder_name: string; }) => item.subfolder_name.toLowerCase() === this.newFolderName.trim().toLowerCase())) {
    //   alert('A folder with this name is already present. Please choose a different name.');
    //   this.newFolderName = '';
    //   return;
    // }
    if (this.editFolderId === 0) {
      if (this.newFolderName.trim()) {
        this.subfolders.push(this.newFolderName);
        this.isLoading = true;

        (await this.eventService.saveSubFolder(this.eventData.eventId, this.newFolderName, 'null')).subscribe({
          next: (res) => {
            // console.log(res); //__CONSOLE_LOG__
            let response: any = res;
            this.subfolders = response.result.event_subfolders;
            // if (this.subfolders.length > 0) {
            //   let _default: any = [];
            //   _default.subfolder_id = 0;
            //   _default.subfolder_name = 'Others';
            // // _default.file_count = this.getImageCount(0);
            //   // this.subfolders.splice(0,0,_default);
            //   this.subfolders.push(_default);
            // }
            this.subfolders.forEach((element: any) => {
              element.subfolder_id = element.id;
            });
            // console.log(this.subfolders); //__CONSOLE_LOG__
            localStorage.setItem('event_subfolders', JSON.stringify(this.subfolders));
            this.isLoading = false;
          },
          error: (err) => {
            // console.error(err); //__CONSOLE_LOG__
            this.isLoading = false;
          },
        });
        this.closeFolderDialog();
      }
    }
    else {
      //edit folder name
      this.isLoading = true;
      (await this.eventService.saveSubFolder(this.eventData.eventId, this.newFolderName, this.editFolderId)).subscribe({
        next: (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any = res;
          this.subfolders = response.result.event_subfolders;
          // if (this.subfolders.length > 0) {
          //   let _default: any = [];
          //   _default.subfolder_id = 0;
          //   _default.subfolder_name = 'Others';
          // // _default.file_count = this.getImageCount(0);
          //   // this.subfolders.splice(0,0,_default);
          //   this.subfolders.push(_default);
          // }
          this.subfolders.forEach((element: any) => {
            element.subfolder_id = element.id;
          });
          // console.log(this.subfolders); //__CONSOLE_LOG__
          localStorage.setItem('event_subfolders', JSON.stringify(this.subfolders));
          this.isLoading = false;
        },
        error: (err) => {
          // console.error(err); //__CONSOLE_LOG__
          this.isLoading = false;
        },
      });
      this.closeFolderDialog();
    }


  }

  editSubfolder(folder: any) {
    // Example: prompt for new name
    // const newName = prompt("Edit folder name:", folder.subfolder_name);
    // if (newName !== null && newName.trim()) {
    //   folder.subfolder_name = newName.trim();
    // }
    this.editFolderId = folder.subfolder_id;
    // console.log(folder.subfolder_id); //__CONSOLE_LOG__

    this.newFolderName = folder.subfolder_name;
    this.openFolderDialog(event, 'edit');

  }

  showToast(message: any) {
    this.toastService.showToast(message);
  }

  async removeSubfolder(folder: any, event: any) {
    event.stopPropagation(); // Prevent the click event from bubbling up to the parent element
    event.preventDefault(); // Prevent the default action of the event
    this.editFolderId = folder.subfolder_id;
    // console.log(folder.subfolder_id); //__CONSOLE_LOG__
    (await this.eventService.removeSubFolder(this.eventData.eventId, this.editFolderId)).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any = res;
        if (response.result == "success") {
          this.subfolders = this.subfolders.filter((f: any) => f !== folder);
        }
        this.subfolders = response.result.event_subfolders;
        if (this.subfolders.length > 0) {
          //let _default: any = [];
          // _default.subfolder_id = 0;
          // _default.subfolder_name = 'Others';
          //// _default.file_count = this.getImageCount(0);
          // this.subfolders.splice(0,0,_default);
          // this.subfolders.push(_default);
        }
        // console.log(this.subfolders); //__CONSOLE_LOG__
        localStorage.setItem('event_subfolders', JSON.stringify(this.subfolders));
        this.isLoading = false;
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
        this.isLoading = false;
      },
    });

  }

  confirmExit() {
    this.confirmMessage = "Are you sure you want to exit this event?";
    this.showConfirmModal = true;
    this.confirmAction = 'exit';
  }


  async previewInvite() {
    // console.log(this.newEventForm); //__CONSOLE_LOG__

    if (this.newEventForm.valid) {
      // console.log(this.newEventForm.value); //__CONSOLE_LOG__
      this.isCreating = true;

      // Combine date and time strings to create full datetime
      const startDateStr = this.newEventForm.value.startTime;
      const startTimeStr = this.newEventForm.value.startTimeString;
      const endDateStr = this.newEventForm.value.endTime;
      const endTimeStr = this.newEventForm.value.endTimeString;
      const timezone = this.newEventForm.value.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Validate required values
      if (!startDateStr || !startTimeStr || !endDateStr || !endTimeStr) {
        // console.error('Missing required date/time values'); //__CONSOLE_LOG__
        this.isCreating = false;
        return;
      }

      // Parse time string (supports "HH:mm" or "h:mm AM/PM") to 24-hour components
      const parseTimeTo24 = (timeStr: string) => {
        if (!timeStr) return { hour: 0, minute: 0 };
        const trimmed = timeStr.trim();
        // If contains AM/PM
        const ampmMatch = trimmed.match(/\b(AM|PM|am|pm)\b/);
        if (ampmMatch) {
          const parts = trimmed.split(' ');
          const timePart = parts[0];
          const meridian = parts[1] ? parts[1].toUpperCase() : '';
          const [hour, minute] = timePart.split(':').map(Number);
          let adjustedHour = hour;
          if (meridian === 'PM' && hour < 12) adjustedHour += 12;
          if (meridian === 'AM' && hour === 12) adjustedHour = 0;
          return { hour: adjustedHour, minute };
        }
        // Assume 24-hour format "HH:mm"
        const [hour24, minute24] = trimmed.split(':').map(Number);
        return { hour: hour24 ?? 0, minute: minute24 ?? 0 };
      };

      const startTimeParsed = parseTimeTo24(startTimeStr);
      const endTimeParsed = parseTimeTo24(endTimeStr);

      // console.log('Saving with timezone:', timezone); //__CONSOLE_LOG__
      // console.log('Start date:', startDateStr, 'time:', startTimeStr, 'parsed:', startTimeParsed); //__CONSOLE_LOG__
      // console.log('End date:', endDateStr, 'time:', endTimeStr, 'parsed:', endTimeParsed); //__CONSOLE_LOG__

      const startTimeStr24 = `${startTimeParsed.hour.toString().padStart(2, '0')}:${startTimeParsed.minute.toString().padStart(2, '0')}`;
      const endTimeStr24 = `${endTimeParsed.hour.toString().padStart(2, '0')}:${endTimeParsed.minute.toString().padStart(2, '0')}`;

      // Create DateTime in the specified timezone and convert to UTC seconds
      const startDateTime = DateTime.fromISO(`${startDateStr}T${startTimeStr24}`, { zone: timezone });
      const endDateTime = DateTime.fromISO(`${endDateStr}T${endTimeStr24}`, { zone: timezone });

      // console.log('Start DateTime (local zone) //__CONSOLE_LOG__:', startDateTime.toString(), 'in UTC:', startDateTime.toUTC().toString());
      // console.log('End DateTime (local zone) //__CONSOLE_LOG__:', endDateTime.toString(), 'in UTC:', endDateTime.toUTC().toString());

      // Epoch seconds in UTC (integer)
      const startEpochSeconds = Math.floor(startDateTime.toUTC().toSeconds());
      const endEpochSeconds = Math.floor(endDateTime.toUTC().toSeconds());

      // Also keep JS Date objects if other code expects them
      const startdateObject = startDateTime.toJSDate();
      const enddateObject = endDateTime.toJSDate();

      // console.log('Start JSDate (ISO) //__CONSOLE_LOG__:', startdateObject.toISOString());
      // console.log('End JSDate (ISO) //__CONSOLE_LOG__:', enddateObject.toISOString());

      this.newEventForm.patchValue({ default_image_id: this.default_image_id })
      this.newEventForm.patchValue({ coverImage: this.coverImage });


      localStorage.setItem('editEvent', 'true');
      let base64Data;
      if (this.coverImage?.startsWith('data')) {
        const parts = this.coverImage.split(',');
        this.coverImage = parts[1];
      }
      else {
        this.coverImage = null;
      }
      // this.router.navigate(['/preview-invite']);
      if (this.newEventForm.untouched && this.newEventForm.value.coverImage == null) {

        this.isCreating = false;
        let editedData: any;
        const formValues = this.newEventForm.value;
        // this.showEventDetail = false;
        editedData = {
          eventId: this.eventData.eventId,
          eventName: formValues.eventName,
          categoryName: formValues.eventCategory,
          start_time: formValues.startTime,
          end_time: formValues.endTime,
          coverImage: formValues.coverImage, // assuming you already have this
          rsvp: formValues.rsvp,
          event_location: formValues.eventLocation,
          message: formValues.message,
          hostName: formValues.hostedBy,
          startTime: formValues.startTime // keep original if needed
        };
        this.coverImage = editedData.coverImage;

        return;
      }
      else {

        const changedValues = this.getChangedValues(this.newEventForm.value, this.originalFormValues);
        // console.log(changedValues); //__CONSOLE_LOG__

        // Check if start date OR start time changed
        const startChanged = changedValues.startTime || changedValues.startTimeString;
        // Check if end date OR end time changed
        const endChanged = changedValues.endTime || changedValues.endTimeString;

        (await this.eventService.updateScheduledEvent(
          this.eventData.eventId,
          changedValues.eventName,
          changedValues.eventLocation,
          changedValues.message != null ? changedValues.message.replace(/^"|"$/g, '') : changedValues.message,
          changedValues.rsvp,
          this.coverImage,
          startChanged ? startEpochSeconds : null,
          endChanged ? endEpochSeconds : null,
          changedValues.eventCategory,
          changedValues.default_image_id,
          changedValues.hostedBy, this.useNow
        )).subscribe({
          next: (res: any) => {
            // console.log(res); //__CONSOLE_LOG__
            // console.log("data after edit:", this.newEventForm.value); //__CONSOLE_LOG__

            let response = res;
            if (response['result'] != 'success') {
              this.isCreating = false;
              this.showMessage = response['result'];
              let editedData: any;
              const formValues = this.newEventForm.value;
              // this.showEventDetail = false;
              editedData = {
                eventId: this.eventData.eventId,
                eventName: formValues.eventName,
                categoryName: formValues.eventCategory,
                start_time: startdateObject.getTime() / 1000,
                end_time: enddateObject.getTime() / 1000,
                coverImage: response['imageUrl'] ? response['imageUrl'] : formValues.coverImage, // = localStorage.getItem('default_image_url');formValues.coverImage, // assuming you already have this
                rsvp: formValues.rsvp,
                event_location: formValues.eventLocation,
                message: formValues.message,
                hostName: formValues.hostedBy,
                startTime: startdateObject.getTime() / 1000 // keep original if needed
              };
              this.coverImage = editedData.coverImage;

              // console.log(editedData); //__CONSOLE_LOG__
              localStorage.setItem('coverImage', this.coverImage);
              this.enc_eventData = this.encryptionService.encryptData(JSON.stringify(editedData));
              localStorage.setItem('eventData', this.enc_eventData);
              localStorage.setItem('formData', this.enc_eventData);
            }
            else if (response['result'] == 'success') {
              // console.log(response); //__CONSOLE_LOG__
              this.showToast("Event updated!");
              this.isCreating = false;
              this.showMessage = '';
              //localStorage.removeItem('e');
              localStorage.removeItem('formData');
              localStorage.removeItem('editEvent');
              localStorage.removeItem('coverImage');
              localStorage.removeItem('qrImage');
              let editedData: any;
              const formValues = this.newEventForm.value;
              // console.log(changedValues); //__CONSOLE_LOG__
              editedData = {
                eventId: this.eventData.eventId,
                eventName: formValues.eventName,
                categoryName: formValues.eventCategory,
                start_time: startdateObject.getTime() / 1000,
                end_time: enddateObject.getTime() / 1000,
                coverImage: response['imageUrl'] ? response['imageUrl'] : formValues.coverImage, // = localStorage.getItem('default_image_url');formValues.coverImage, // assuming you already have this
                rsvp: formValues.rsvp,
                event_location: formValues.eventLocation,
                message: formValues.message,
                hostName: formValues.hostedBy,
                startTime: startdateObject.getTime() / 1000 // keep original if needed
              };
              this.coverImage = editedData.coverImage;

              // console.log(editedData); //__CONSOLE_LOG__
              localStorage.setItem('coverImage', this.coverImage);


              this.enc_eventData = this.encryptionService.encryptData(JSON.stringify(editedData));
              localStorage.setItem('eventData', this.enc_eventData);
              localStorage.setItem('formData', this.enc_eventData);

              // Update the eventData with new values
              this.eventData = editedData;
              // Use fresh data method to bypass cache after updating
              this.eventService.getTotalMediaCountFresh(localStorage.getItem('eventId')).subscribe({
                next: (res) => {
                  // console.log('Fresh invite data from server:', res); //__CONSOLE_LOG__
                  if (res) {
                    let inviteRes = res;
                    // console.log({ inviteRes }); //__CONSOLE_LOG__

                    // Store the fresh data
                    this.inviteData = inviteRes;

                    // Encrypt and save to localStorage for next time
                    this.encryptedIData = this.encryptionService.encryptData(JSON.stringify(inviteRes));
                    localStorage.setItem('invite-info', this.encryptedIData);
                    // Also update inviteData so event-detail reads fresh values
                    localStorage.setItem('inviteData', this.encryptedIData);

                    // Update originalFormValues to prevent "no data to update" on next save
                    this.originalFormValues = { ...this.newEventForm.value };

                    // console.log('Updated invite-info and inviteData in localStorage with fresh data'); //__CONSOLE_LOG__
                  }

                  // Only after getting fresh data, disable form and show success
                  // this.isEditable = false;
                  // this.newEventForm.disable();
                  // this.showToast('Changes saved');
                },
                error: (err) => {
                  // console.error('Error fetching fresh invite data:', err); //__CONSOLE_LOG__
                  // Even if API fails, still show success for the update
                  // this.isEditable = false;
                  // this.newEventForm.disable();
                  // this.showToast('Changes saved');
                },
              });

              // Update form with the saved values
              const savedStartDate = new Date(editedData.start_time * 1000);
              const savedEndDate = new Date(editedData.end_time * 1000);
              this.newEventForm.patchValue({
                eventName: editedData.eventName,
                eventCategory: editedData.categoryName,
                startTime: this.formatDateToString(savedStartDate),
                startTimeString: this.formatTimeToString(savedStartDate),
                endTime: this.formatDateToString(savedEndDate),
                endTimeString: this.formatTimeToString(savedEndDate),
                hostedBy: editedData.hostName,
                eventLocation: editedData.event_location,
                message: editedData.message,
                rsvp: editedData.rsvp,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone // Reset to browser's local timezone
              });

              // Clear timezone search text and reset filtered list
              this.timezoneSearchText = '';
              this.filteredTimezones = [...this.timezones];

              // Update original form values and disable form to stay on the same page
              this.originalFormValues = { ...this.newEventForm.value };
              this.isEditable = false;
              this.newEventForm.disable();

              // Manage Event is the merged hub for event details — once it's
              // available for this build, send hosts back there after saving
              // instead of leaving them on this classic settings page.
              localStorage.removeItem('manageEventReturn');
              if (this.env.features.manageEventHub) {
                this.router.navigate(['/manage-event']);
                return;
              }
            }
          }
        });

      }

    } else {
      const invalidFields: string[] = [];

      Object.keys(this.newEventForm.controls).forEach(key => {
        const control = this.newEventForm.get(key);
        if (control?.hasError('required')) {
          control.markAsTouched(); // so errors show up in UI
          invalidFields.push(key);
        }
      });

      // console.log('Required validation failed for:', invalidFields); //__CONSOLE_LOG__
      // Mark all fields as touched to show validation errors
      this.newEventForm.markAllAsTouched();
    }
  }

  confirmDelete() {
    this.confirmMessage = "Deleting the event will delete all media files present in this event.Are you sure you want to delete this event?";
    this.showConfirmModal = true;
    this.confirmAction = 'delete';
  }

  onChangeConfirmed(confirmed: any) {
    if (confirmed) {
      this.isLoading = true;
      if (this.confirmAction === 'exit') {
        this.exitEvent();
      }
      else if (this.confirmAction === 'delete') {
        this.deleteEvent();
      }
    }
    this.showConfirmModal = false;
  }

  async exitEvent() {
    this.isLoading = true;

    (await this.eventService.exitEvent(this.eventData.eventId)).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any = res;
        this.isLoading = false;
        this.goBacktoHome();
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
        this.isLoading = false;
      },
    });
  }

  async deleteEvent() {
    this.isLoading = true;
    (await this.eventService.deleteEvent(this.eventData.eventId)).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any = res;
        this.isLoading = false;
        this.showToast("Event deleted successfully!");

        // Clear all localStorage data
        localStorage.removeItem('eventId');
        localStorage.removeItem('showTimerCard');
        localStorage.removeItem('showInviteCard');
        localStorage.removeItem('access');
        localStorage.removeItem('isEventId');
        localStorage.removeItem('event_hash');
        localStorage.removeItem('event_name');
        localStorage.removeItem('e');
        localStorage.removeItem('isHost');
        localStorage.removeItem('inviteData');
        localStorage.removeItem('eventData');
        localStorage.removeItem('isScheduled');
        localStorage.removeItem('qrcode');
        localStorage.removeItem('savedHashtags');
        localStorage.removeItem('name');
        localStorage.removeItem('invite_resp');
        localStorage.removeItem('event_subfolders');
        localStorage.removeItem('web_qrImage');
        localStorage.removeItem('web_viewer_qrImage');
        localStorage.removeItem('coverImage');
        localStorage.removeItem('openPopup');
        localStorage.removeItem('formData');
        localStorage.removeItem('isFutureEvent');

        // Navigate to home and refresh
        this.router.navigate(['/home']).then(() => {
          reloadApp('event_updated');
        });
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
        this.isLoading = false;
      },
    });
  }


  toggleMenu(index: number, event: MouseEvent): void {
    event.stopPropagation(); // prevent triggering outside click
    // console.log(this.filteredGuests); //__CONSOLE_LOG__
    const btn = event.currentTarget as HTMLElement;
    const rect = btn.getBoundingClientRect();
    this.menuPosition = {
      top: rect.bottom + 4,
      right: window.innerWidth - rect.right,
    };
    this.openMenuIndex = this.openMenuIndex === index ? null : index;
    this.selectedMenuGuest = this.openMenuIndex !== null ? this.filteredGuests[index] : null;
  }

  closeMenu(): void {
    this.openMenuIndex = null;
    this.selectedMenuGuest = null;
  }

  async removeUser(guest_id: any): Promise<void> {
    // Your actual removal logic here
    // console.log('User removed', this.eventData.eventId, guest_id); //__CONSOLE_LOG__
    (await this.eventService.removeUser(this.eventData.eventId, guest_id)).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any = res;
        this.collaborators = this.collaborators.filter((user: { user_id: any; }) => user.user_id !== guest_id);
        this.isLoading = false;
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
        this.isLoading = false;
      },
    });
    this.closeMenu();
  }


  toggleNowCheckbox() {
    // console.log('Use now:', this.useNow) //__CONSOLE_LOG__
    const control = this.newEventForm.controls.startTime;//.get('startTime');
    if (this.useNow) {
      const now = new Date();
      control?.setValue(now.toISOString());
      this.newEventForm.value.endTime = null;
      //  control?.disable();
    } else {
      control?.enable();
    }
  }

  getChangedValues(current: any, original: any): any {
    const result: any = {};
    Object.keys(current).forEach(key => {
      const currentVal = current[key];
      const originalVal = original[key];

      // Compare Date values accurately
      if (currentVal instanceof Date && originalVal instanceof Date) {
        result[key] = currentVal.getTime() !== originalVal.getTime() ? currentVal : null;
      } else {
        result[key] = currentVal !== originalVal ? currentVal : null;
      }
    });
    return result;
  }


  openFolderDialog(event: any, action: any) {
    event.stopPropagation(); // Prevent the click event from bubbling up to the parent element
    event.preventDefault(); // Prevent the default action of the event
    this.isFolderDialogOpen = true;
    if (action === 'edit') {
      this.popupTitle = 'Edit Album Name';
    } else {
      this.editFolderId = 0;
      this.newFolderName = '';
      this.popupTitle = 'Add New Album';
    }
  }

  closeFolderDialog() {
    this.isFolderDialogOpen = false;
    this.newFolderName = '';
  }


  validateEndTimeAfterStartTimeAndMaxDuration(group: AbstractControl): ValidationErrors | null {

    const startDateStr = group.get('startTime')?.value;
    const startTimeStr = group.get('startTimeString')?.value;
    const endDateStr = group.get('endTime')?.value;
    const endTimeStr = group.get('endTimeString')?.value;

    if (!startDateStr || !endDateStr || !startTimeStr || !endTimeStr) return null;

    // Combine date and time strings to create full datetime
    const startDate = new Date(`${startDateStr}T${startTimeStr}`);
    const endDate = new Date(`${endDateStr}T${endTimeStr}`);

    if (endDate <= startDate) {
      return { endBeforeStart: true };
    }

    const durationInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
    if (durationInDays > 10) {
      return { durationExceedsLimit: true };
    }

    return null;

  }


  incrementSection(): void {
    this.isCreating = true;

    if (this.newEventForm.valid) {
      // Don't increment section, just save
      this.previewInvite();
    }
    else {
      this.isCreating = false;
      this.newEventForm.markAllAsTouched();
      return;
    }
  }


  goBacktoHome() {

    if (localStorage.getItem('eventId')) {
      localStorage.removeItem('eventId');
    }
    if (localStorage.getItem('showTimerCard')) {
      localStorage.removeItem('showTimerCard');
    }
    if (localStorage.getItem('showInviteCard')) {
      localStorage.removeItem('showInviteCard');
    }
    if (localStorage.getItem('access')) {
      localStorage.removeItem('access');
    }
    if (localStorage.getItem('isEventId')) {
      localStorage.removeItem('isEventId');
    }
    if (localStorage.getItem('event_hash')) {
      localStorage.removeItem('event_hash');
    }

    if (localStorage.getItem('event_name')) {
      localStorage.removeItem('event_name');
    }

    if (localStorage.getItem('e')) {
      localStorage.removeItem('e');
    }

    if (localStorage.getItem('isHost')) {
      localStorage.removeItem('isHost');
    }

    if (localStorage.getItem('inviteData')) {
      localStorage.removeItem('inviteData');
    }

    if (localStorage.getItem('eventData')) {
      localStorage.removeItem('eventData');
    }

    if (localStorage.getItem('isScheduled')) {
      localStorage.removeItem('isScheduled');
    }

    if (localStorage.getItem('qrcode')) {
      localStorage.removeItem('qrcode');
    }
    if (localStorage.getItem('savedHashtags')) {
      localStorage.removeItem('savedHashtags');
    }
    if (localStorage.getItem('name')) {
      localStorage.removeItem('name');
    }
    if (localStorage.getItem('invite_resp')) {
      localStorage.removeItem('invite_resp');
    }
    if (localStorage.getItem('event_subfolders')) {
      localStorage.removeItem('event_subfolders');
    }
    if (localStorage.getItem('web_qrImage')) {
      localStorage.removeItem('web_qrImage');
    }
    if (localStorage.getItem('web_viewer_qrImage')) {
      localStorage.removeItem('web_viewer_qrImage');
    }
    if (localStorage.getItem('coverImage')) {
      localStorage.removeItem('coverImage');
    }

    if (localStorage.getItem('openPopup')) {
      localStorage.removeItem('openPopup');
    }
    if (localStorage.getItem('formData')) {
      localStorage.removeItem('formData');
    }
    if (localStorage.getItem('isFutureEvent')) {
      localStorage.removeItem('isFutureEvent');
    }

    this.router.navigate(['/home']);
  }

  showDefaultTabOptions() {
    // For mobile view - navigate to full page
    if (this.isMobile) {
      this.currentSection = 3;
      this.showFullPage = true;
    } else {
      this.currentSection = 3;
    }
  }

  showBulkDownloadOptions() {
    // For mobile view - navigate to full page
    if (this.isMobile) {
      this.currentSection = 4;
      this.showFullPage = true;
    } else {
      this.currentSection = 4;
    }
  }

  showSortOrderOptions() {
    if (this.isMobile) {
      this.currentSection = 7;
      this.showFullPage = true;
    } else {
      this.currentSection = 7;
    }
  }

  showGuestUploadsOptions() {
    if (this.isMobile) {
      this.currentSection = 8;
      this.showFullPage = true;
    } else {
      this.currentSection = 8;
    }
  }

  async saveDefaultTab() {
    if (!this.eventId) {
      this.toastService.showToast('We lost track of which album this is. Go back and open it again.', 0);
      return;
    }

    const defaultTab = this.newEventForm.get('defaultTab')?.value;
    if (!defaultTab) {
      this.toastService.showToast('Please select a default tab', 0);
      return;
    }

    this.isLoading = true;
    try {
      (await this.eventService.updateDefaultTab(this.eventId, defaultTab)).subscribe({
        next: (response: any) => {
          // console.log('Default tab updated successfully:', response); //__CONSOLE_LOG__
          this.toastService.showToast('Default tab updated successfully', 1);
          this.isEditable = false;
          this.newEventForm.disable();
          this.isLoading = false;
        },
        error: (err: any) => {
          // console.error('Error updating default tab:', err); //__CONSOLE_LOG__
          this.toastService.showToast('Failed to update default tab', 0);
          this.isLoading = false;
        }
      });
    } catch (error) {
      // console.error('Error updating default tab:', error); //__CONSOLE_LOG__
      this.toastService.showToast('An error occurred', 0);
      this.isLoading = false;
    }
  }

  async saveBulkDownloadSetting() {
    if (!this.eventId) {
      this.toastService.showToast('We lost track of which album this is. Go back and open it again.', 0);
      return;
    }

    const allowBulkDownload = this.newEventForm.get('allowBulkDownload')?.value ?? false;

    this.isLoading = true;
    try {
      (await this.eventService.updateBulkDownloadPermission(this.eventId, allowBulkDownload)).subscribe({
        next: (response: any) => {
          // console.log('Bulk download permission updated successfully:', response); //__CONSOLE_LOG__
          this.toastService.showToast('Bulk download permission updated successfully', 1);
          this.isEditable = false;
          this.newEventForm.disable();
          this.isLoading = false;
        },
        error: (err: any) => {
          // console.error('Error updating bulk download permission:', err); //__CONSOLE_LOG__
          this.toastService.showToast('Failed to update bulk download permission', 0);
          this.isLoading = false;
        }
      });
    } catch (error) {
      // console.error('Error updating bulk download permission:', error); //__CONSOLE_LOG__
      this.toastService.showToast('An error occurred', 0);
      this.isLoading = false;
    }
  }

  async saveSortOrder() {
    if (!this.eventId) {
      this.toastService.showToast('Event ID not found', 0);
      return;
    }

    const sortOrder = this.newEventForm.get('sortOrder')?.value || 'desc';

    this.isLoading = true;
    try {
      (await this.eventService.updateDefaultSortOrder(this.eventId.toString(), sortOrder)).subscribe({
        next: () => {
          this.currentSortOrder = sortOrder;
          this.toastService.showToast('Sorting order updated successfully', 1);
          this.isEditable = false;
          this.newEventForm.disable();
          this.isLoading = false;
        },
        error: () => {
          this.toastService.showToast('Failed to update sorting order', 0);
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.toastService.showToast('An error occurred', 0);
      this.isLoading = false;
    }
  }

  /** The QR image that matches the current "Allow guest uploads" choice. */
  get guestUploadsQrImage(): string {
    return this.allowGuestUploads
      ? localStorage.getItem('web_qrImage') || ''
      : localStorage.getItem('web_viewer_qrImage') || '';
  }

  /** The link that matches the current "Allow guest uploads" choice. */
  get guestUploadsLink(): string {
    const hash = this.allowGuestUploads ? localStorage.getItem('event_hash') : localStorage.getItem('viewer_hash');
    return hash ? inviteLinkFor(hash) : '';
  }

  get guestUploadsHint(): string {
    return this.allowGuestUploads
      ? 'Guests who scan this code or open this link can view and upload photos.'
      : 'Guests who scan this code or open this link can only view photos — uploads are off. Guests who already have the collaborator link or QR code can still upload, regardless of this setting.';
  }

  copyGuestUploadsLink(): void {
    if (!this.guestUploadsLink) return;
    navigator.clipboard.writeText(this.guestUploadsLink).then(() => {
      this.guestUploadsLinkCopied = true;
      setTimeout(() => { this.guestUploadsLinkCopied = false; }, 2000);
    });
  }

  cancelEdit() {
    this.isEditable = false;
    this.newEventForm.disable();
    // Reset form to original values if needed
    this.newEventForm.patchValue(this.originalFormValues);
  }

  goBack() {
    // If navigated from manage-event, return there
    if (localStorage.getItem('manageEventReturn') === 'true') {
      localStorage.removeItem('manageEventReturn');
      this.router.navigate(['/manage-event']);
      return;
    }
    let hex = localStorage.getItem('eventId');
    this.access = localStorage.getItem('access') ? localStorage.getItem('access') : '';
    //
    // console.log('Access type on goBack:', this.access); //__CONSOLE_LOG__ //__CONSOLE_LOG__
    if (this.access !== 'restricted') {
      this.router.navigate(['/event-detail/true']);
    }
    else {
      this.router.navigate(['/my-photos/' + hex]);
    }

  }

  // ==================== Branding Methods ====================

  initBrandingForm() {
    this.brandingForm = this.fb.group({
      brandName: ['', [Validators.required, Validators.maxLength(100)]],
      facebookLink: ['', [Validators.pattern(/^(https?:\/\/)?(www\.)?facebook\.com\/.+/i)]],
      instagramLink: ['', [Validators.pattern(/^(https?:\/\/)?(www\.)?instagram\.com\/.+/i)]],
      websiteLink: ['', [Validators.pattern(/^(https?:\/\/)[\w\-]+(\.[\w\-]+)+[/#?]?.*$/)]],
      phoneNumber: ['', [Validators.pattern(/^[+]?[\d\s()-]{10,15}$/)]],
      isActive: [true]
    });
  }

  async loadBrandingData() {
    if (!localStorage.getItem('e')) {
      this.toastService.showToast('We lost track of which album this is. Go back and open it again.', 0);
      return;
    }

    this.isLoading = true;
    try {
      (await this.eventService.getEventBranding(localStorage.getItem('e'))).subscribe({
        next: (response: any) => {
          if (response && response.result) {
            const data = response.result;
            this.isBrandingActive = data.showEventBranding;
            this.brandingForm.patchValue({
              brandName: data.name || '',
              facebookLink: data.facebook_link || '',
              instagramLink: data.instagram_link || '',
              websiteLink: data.website || '',
              phoneNumber: data.phone_number || '',
              isActive: this.isBrandingActive
            });
            this.logoUrl = data.logoUrl || null;
            this.existingLogoName = data.logo_name || null;
            this.originalBrandingFormValues = this.brandingForm.value;
          }
          this.isLoading = false;
        },
        error: (err: any) => {
          // console.error('Error loading branding data:', err); //__CONSOLE_LOG__
          this.toastService.showToast('Failed to load branding data', 0);
          this.isLoading = false;
        }
      });
    } catch (error) {
      // console.error('Error:', error); //__CONSOLE_LOG__
      this.isLoading = false;
    }
  }

  cancelBrandingEdit() {
    this.brandingForm.patchValue(this.originalBrandingFormValues);
    this.logoFile = null;
    this.isEditable = false;
  }

  async onToggleChange() {
    const isActive = this.brandingForm.get('isActive')?.value;
    const eventId = localStorage.getItem('e');
    if (!eventId) {
      this.toastService.showToast('We lost track of which album this is. Go back and open it again.', 0);
      return;
    }

    try {
      (await this.eventService.updateEventBrandingStatus(eventId, isActive)).subscribe({
        next: (response: any) => {
          this.toastService.showToast(`Branding ${isActive ? 'enabled' : 'disabled'} successfully`, 1);
          this.isBrandingActive = isActive;
        },
        error: (err: any) => {
          // console.error('Error updating branding status:', err); //__CONSOLE_LOG__
          this.toastService.showToast('Failed to update branding status', 0);
          // Revert toggle on error
          this.brandingForm.patchValue({ isActive: !isActive });
        }
      });
    } catch (error) {
      // console.error('Error:', error); //__CONSOLE_LOG__
      this.toastService.showToast("Couldn't save your changes. Check your connection and try again.", 0);
      // Revert toggle on error
      this.brandingForm.patchValue({ isActive: !isActive });
    }
  }

  onLogoSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Validate file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.toastService.showToast('Logo size should not exceed 2MB', 0);
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.toastService.showToast('Please select a valid image file', 0);
        return;
      }

      this.logoFile = file;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.logoUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  triggerFileInput() {
    const fileInput = document.getElementById('logoInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  removeLogo() {
    this.logoUrl = null;
    this.logoFile = null;
    this.generatedLogoName = null;
    const fileInput = document.getElementById('logoInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  async uploadLogoToS3(): Promise<string | null> {
    if (!this.logoFile) return this.logoUrl;

    try {
      // Get Firebase token for Cognito authentication
      const currentUser = await this.afAuth.currentUser;
      if (!currentUser) {
        throw new Error("No authenticated user found.");
      }

      const firebaseToken = await currentUser.getIdToken(true);
      if (!firebaseToken) {
        throw new Error('Failed to acquire firebase token for Cognito authentication');
      }

      // Create S3 client with Cognito Identity Pool credentials (fetched lazily)
      const region = 'us-west-1';
      const s3 = await createS3Client({
        region,
        credentials: await createCognitoCredentials({
          identityPoolId: this.identityPoolId,
          logins: {
            'securetoken.google.com/picaggo-235807': firebaseToken
          },
          clientConfig: { region }
        })
      });

      // Create unique file name based on eventId
      const fileExtension = this.logoFile.name.substring(this.logoFile.name.lastIndexOf('.'));
      const timestamp = Date.now();
      this.generatedLogoName = `${this.eventId}_${timestamp}${fileExtension}`;
      const fileName = `event-branding/${this.eventId}/${this.generatedLogoName}`;

      const params = {
        Bucket: environment.aws.bucketName,
        Key: fileName,
        Body: this.logoFile,
        ContentType: this.logoFile.type
      };

      const data = await (await createUpload({ client: s3, params })).done();
      return (data as any).Location;
    } catch (error) {
      // console.error('Error uploading logo:', error); //__CONSOLE_LOG__
      this.toastService.showToast('Failed to upload logo', 0);
      return null;
    }
  }

  async saveBranding() {
    if (this.brandingForm.invalid) {
      this.toastService.showToast('Some fields still need filling in.', 0);
      Object.keys(this.brandingForm.controls).forEach(key => {
        this.brandingForm.get(key)?.markAsTouched();
      });
      return;
    }

    this.isLoading = true;

    try {
      // Upload logo if changed
      let uploadedLogoUrl = this.logoUrl;
      if (this.logoFile) {
        uploadedLogoUrl = await this.uploadLogoToS3();
        if (!uploadedLogoUrl) {
          this.isLoading = false;
          return;
        }
      }

      const brandingData = {
        event_id: this.eventId,
        name: this.brandingForm.value.brandName,
        logo_name: this.logoFile ? this.generatedLogoName : this.existingLogoName,
        facebook_link: this.brandingForm.value.facebookLink,
        instagram_link: this.brandingForm.value.instagramLink,
        website: this.brandingForm.value.websiteLink,
        phone_number: this.brandingForm.value.phoneNumber,
        is_active: this.brandingForm.value.isActive
      };

      (await this.eventService.saveEventBranding(brandingData)).subscribe({
        next: (response: any) => {
          this.toastService.showToast('Branding settings saved successfully', 1);
          this.isEditable = false;
          this.originalBrandingFormValues = this.brandingForm.value;
          // Update existingLogoName if a new logo was uploaded
          if (this.generatedLogoName) {
            this.existingLogoName = this.generatedLogoName;
          }
          this.logoFile = null;
          this.generatedLogoName = null;
          this.isLoading = false;
        },
        error: (err: any) => {
          // console.error('Error saving branding:', err); //__CONSOLE_LOG__
          this.toastService.showToast('Failed to save branding settings', 0);
          this.isLoading = false;
        }
      });
    } catch (error) {
      // console.error('Error:', error); //__CONSOLE_LOG__
      this.toastService.showToast("Couldn't save that. Check your connection and try again.", 0);
      this.isLoading = false;
    }
  }

  async updateDefaultTab(eventId: string, defaultTab: string) {
    try {
      (await this.eventService.updateDefaultTab(eventId, defaultTab)).subscribe({
        next: (response: any) => {
          // console.log('Default tab updated successfully:', response); //__CONSOLE_LOG__
        },
        error: (err: any) => {
          // console.error('Error updating default tab:', err); //__CONSOLE_LOG__
        }
      });
    } catch (error) {
      // console.error('Error updating default tab:', error); //__CONSOLE_LOG__
    }
  }
}
